import { render, staticRenderFns } from "./WPInfoProfileBlock.vue?vue&type=template&id=8b7215da"
import script from "./WPInfoProfileBlock.vue?vue&type=script&lang=ts"
export * from "./WPInfoProfileBlock.vue?vue&type=script&lang=ts"
import style0 from "./WPInfoProfileBlock.vue?vue&type=style&index=0&id=8b7215da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports